
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Check, X } from "lucide-react";

interface PhoneNumberFieldProps {
  phoneNumber: string;
  isVerified: boolean;
  loading: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onVerificationRequest: () => void;
}

export const PhoneNumberField = ({
  phoneNumber,
  isVerified,
  loading,
  onChange,
  onVerificationRequest,
}: PhoneNumberFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="phone_number">
        Phone Number
        {phoneNumber && (
          <span className="ml-2 inline-flex items-center">
            {isVerified ? (
              <span className="text-xs text-green-600 flex items-center">
                <Check className="h-3 w-3 mr-1" /> Verified
              </span>
            ) : (
              <span className="text-xs text-red-600 flex items-center">
                <X className="h-3 w-3 mr-1" /> Not verified
              </span>
            )}
          </span>
        )}
      </Label>
      <div className="flex gap-2">
        <Input
          id="phone_number"
          name="phone_number"
          type="tel"
          value={phoneNumber}
          onChange={onChange}
          placeholder="+1 (555) 123-4567"
          disabled={loading}
          className="flex-1"
        />
        {phoneNumber && !isVerified && (
          <Button 
            type="button" 
            variant="outline" 
            onClick={onVerificationRequest}
          >
            Verify
          </Button>
        )}
      </div>
      {phoneNumber && !isVerified && (
        <p className="text-xs text-muted-foreground">
          Please verify your phone number to receive SMS notifications
        </p>
      )}
    </div>
  );
};
